import { Flex, Tooltip } from '@chakra-ui/react'
import { formatPrice } from '../../../../../utils/formatPrice'
import { Trow } from './Trow'

export function CardProducts({ item, index, onClick, firstLetterUpper }) {
  const valorTotalVenda =
    parseFloat(item.valor_unit) * parseInt(item.quantidade_negociada)

  const precoTotalBase =
    parseFloat(item.preco_base) * parseInt(item.quantidade_negociada)

  return (
    <Flex
      flex={1}
      w="100%"
      align="center"
      justify="space-between"
      gap={'.1rem'}
      onClick={() => onClick(item)}
    >
      <Flex flexDir="column">
        <Trow value={item.codprod} index={index} />
      </Flex>
      <Flex flexDir="column">
        <Trow
          value={
            <Tooltip
              label={item.descricao_produto}
              fontSize="sm"
              placement="top"
              hasArrow
            >
              {item.descricao_produto.length > 25
                ? firstLetterUpper(item.descricao_produto.substring(0, 25)) +
                  '...'
                : firstLetterUpper(item.descricao_produto)}
            </Tooltip>
          }
          width="12.5rem"
          index={index}
        />
      </Flex>
      <Flex flexDir="column">
        <Trow
          value={
            item.cor.length > 13
              ? firstLetterUpper(item.cor.substring(0, 13)) + '...'
              : firstLetterUpper(item.cor)
          }
          width="130px"
          index={index}
        />
      </Flex>
      <Flex flexDir="column">
        <Trow value={parseInt(item.quantidade_negociada)} index={index} />
      </Flex>
      <Flex flexDir="column">
        <Trow value={formatPrice(item.preco_base)} index={index} />
      </Flex>
      <Flex flexDir="column">
        <Trow value={formatPrice(item.valor_unit)} index={index} />
      </Flex>
      <Flex flexDir="column">
        <Trow
          value={formatPrice(valorTotalVenda)}
          index={index}
          width="7.5rem"
        />
      </Flex>
      <Flex flexDir="column">
        <Trow
          value={formatPrice(precoTotalBase)}
          index={index}
          width="7.5rem"
        />
      </Flex>
      <Flex flexDir="column">
        <Trow
          value={formatPrice(precoTotalBase - item.lucro_bruto)}
          // value={formatPrice(item.custo_total)}
          index={index}
        />
      </Flex>
      <Flex flexDir="column">
        <Trow value={formatPrice(item.lucro_bruto)} index={index} />
      </Flex>
      <Flex flexDir="column">
        <Trow
          value={parseFloat(item.porcentagem).toFixed(2) + '%'}
          index={index}
          width="7rem"
        />
      </Flex>
    </Flex>
  )
}
